{
  "edit": {
    "header": "Timetable",
    "add_custom_class": "Add Class",
    "add_custom_class_dialog_description": "Select the class to add to the timetable.",
    "add_team_custom_class_dialog_description": "Select the class to add to the timetable and specify the number of classes to run",
    "add_priority_below": "Add Priority Below",
    "timezone": "Timezone",
    "num_classes": "Number of Classes",
    "schedule": {
      "duration": "{{duration}} minutes",
      "fixed": "Day {{day}} {{start}} - {{end}}",
      "fixed_timezone": "(Day {{day}} {{start}} - {{end}} {{timezone}})",
      "priority": "Priority {{priority}}",
      "dialog": {
        "header": "Schedule Session",
        "description": "Please use the form below to specify a day and time for this session"
      },
      "form": {
        "day_label": "Day",
        "start_time": "Start Time",
        "submit_add": "Add Session",
        "submit_edit": "Update Session",
        "end_time": "End Time",
        "day": "Day {{day}}"
      }
    },
    "events": {
      "short_title": "P{{priority}} {{subjectCode}}"
    },
    "actions": {
      "publish": "Publish",
      "publish_description": "Once published, schools can assign preferences to your timetable priorities. If one of your timetable priorities goes live, you must provide teaching services at the agreed upon dates and times for the duration of the class.",
      "publish_success": "Timetable published.",
      "publish_pending": "Publishing..."
    }
  },
  "errors": {
    "common": "Failed to save timetable",
    "overlap": "Session cannot overlap with a different class"
  }
}
